module.exports = __webpack_public_path__ + "static/media/nishanttilve.bdabc4ce.jpg";